/**
 * 跨站共享字段通用读写入口
 * @author jero
 * @date 2016-12-07
 */
import cookie from '@tencent/im-cookie';

import util from './util';


const cookieConfig = {
    name: 'tdw_data_new_2',
    domain: 'ke.qq.com',
    path: '/'
};

function encodeData(d) {
  const n = {};
  Object.keys(d).forEach((k) => {
    n[k] = encodeURIComponent(d[k]||'');
  });
  return n;
}

export function setCookieData(value) {
  if (util.isPlainObject(value)) {
    value = encodeData(value);
    value = JSON.stringify(value);
  }

    cookie.setSession(cookieConfig.name, value, cookieConfig.domain, cookieConfig.path);
}

export function getCookieData() {
  let d;
    try {
        d = cookie.get(cookieConfig.name);
        d = JSON.parse(d);
    } catch (e) {
        d = {};
    }
    return d;
}







